import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import PrimaryTransportationTable from "./FGBomTable";
import btnDownloadIcon from "../../../Assests/download-icon.svg";
import btnSaveIcon from "../../../Assests/Save-btn.svg";
import {
  EditProductTableSuccess,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
  enableEditFilter,
} from "../../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  BULK_EDIT_MANUFACTURING_MASTER_TABLE_API,
  DISPLAY_MANUFACTURING_MASTER_1_TABLE_API,
  DOWNLOAD_MANUFACTURING_MASTER_1_TABLE_API,
  LONG_Download_FGBOM_Module3,
  LONG_FACILITY_MASTER_GET_API,
  LONG_GETALL_FGBOM,
  LONG_GETALL_FGBOM_Module3,
  LONG_PRIMARY_TRANSPORTATION_DOWNLOAD_API,
  LONG_PRIMARY_TRANSPORTATION_GET_API,
  LONG_UPDATE_BULK_EDIT_FGB_API,
  LONG_UPDATE_BULK_EDIT_FGB_API_Module3,
  LONG__FGBOM_DOWNLOAD_API,
  UPDATE_BULK_PRI_TRA_BY_IDS,
  UPDATE_PROCESSING_PLANTS_BY_IDS,
  VIEW_MANUFACTURING_MASTER_1_TABLE_API,
} from "../../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import FGBomTable from "./FGBomTable";

import AddRowButton from "../../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../../Components/Common/ConfirmationDialog";

function FGBom(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();

  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);

  // on change values for filters

  const [selectPackagingPlantCode, setSelectPackagingPlantCode] =
    useState<any>("");
  const [selectFgCode, setselectFgCode] = useState<any>("");
  const [selectSFGType, setselectSFGType] = useState<any>("");
  const [selectFGDescription, setSelectFGDescription] = useState<any>("");
  const [selectRMPMDescription, setselectRMPMDescription] = useState<any>("");
  const [selectSFGCode, setselectSFGCode] = useState<any>("");

  /// options for filters
  const [packagingPlantCodeOptions, setPackagingPlantCodeOptions] =
    React.useState([]);
  const [fgCodeOptions, setfgCodeOptions] = useState<any>([]);

  const [fgDescriptionOption, setFGDescriptionOption] = useState<any>([]);
  const [sfgCodeOption, setsfgCodeOption] = useState<any>([]);
  const [sfgTypeOption, setsfgTypeOption] = useState<any>([]);

  const [rmpmDescriptionOption, setRmpmDescriptionOption] = useState<any>([]);
  const [lineOptions, setLineOptions] = useState<any>([]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);

  const [filterRequest, setFilterRequest] = React.useState([
    { key: "packaging_Plant_Code", value: "" },
    { key: "fG_Code", value: "" },
    { key: "fG_Description", value: "" },
    { key: "sfG_PM_Type", value: "" },
    { key: "sfG_PM_Code", value: "" },
    { key: "sfG_PM_Description", value: "" },
    { key: "rM_PM_Code", value: "" },
    { key: "rM_PM_Description", value: "" },
  ]);

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  const sortedPackagingPlantCodeNames = packagingPlantCodeOptions?.sort(
    (a: any, b: any) =>
      a?.packaging_Plant_Code.localeCompare(b?.packaging_Plant_Code)
  );

  const selectedFolderData = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderData
  );

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  /**Redux state */
  const selectedUsecaseeId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage
  );

  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);
  const [tableName, setTableName] = useState<any>("tblScenario_FGBOM_LT");

  useEffect(() => {
    if (folderModuleName === "module2") {
      setTableName("tblScenario_FGBOM_LT_Module2");
      callTableGridApi("tblScenario_FGBOM_LT_Module2");
    } else if (folderModuleName === "module3") {
      setTableName("tblScenario_FGBOM_LT_Module3");
      callTableGridApi("tblScenario_FGBOM_LT_Module3");
    } else if (folderModuleName === "module4") {
      setTableName("tblScenario_FGBOM_LT_Module4");
      callTableGridApi("tblScenario_FGBOM_LT_Module4");
    } else if (folderModuleName === "module5") {
      setTableName("tblScenario_FGBOM_LT_Module5");
      callTableGridApi("tblScenario_FGBOM_LT_Module5");
    } else if (folderModuleName === "module6") {
      setTableName("tblScenario_FGBOM_LT_Module6");
      callTableGridApi("tblScenario_FGBOM_LT_Module6");
    } else {
      setTableName("tblScenario_FGBOM_LT");
      callTableGridApi("tblScenario_FGBOM_LT");
    }
  }, [folderModuleName, selectedScenarioId]);

  var PPC = 0;
  var FGC = 0;
  var SFGT = 0;
  var SFGC = 0;
  var RMPM = 0;
  var FGD = 0;

  const handleSelectPackagingPlantCode = (event: any) => {
    setselectFgCode("");
    setselectSFGType("");
    setselectRMPMDescription("");
    setselectSFGCode("");
    setSelectFGDescription("");
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    const {
      target: { value },
    } = event;
    setSelectPackagingPlantCode(value);
    filterRequest[0].value = value;
    callTableGridApi();
    PPC = 1;
    FGC = 0;
    SFGT = 0;
    SFGC = 0;
    RMPM = 0;
    FGD = 0;
  };

  const handleSelectFgCode = (event: any) => {
    setselectSFGType("");
    setselectRMPMDescription("");
    setselectSFGCode("");
    setSelectFGDescription("");
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    const {
      target: { value },
    } = event;
    setselectFgCode(value);
    filterRequest[1].value = value;
    callTableGridApi();
    PPC = 1;
    FGC = 1;
    SFGT = 0;
    SFGC = 0;
    RMPM = 0;
    FGD = 0;
  };

  const handleSFGType = (event: any) => {
    setselectRMPMDescription("");
    setselectSFGCode("");
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    const {
      target: { value },
    } = event;
    setselectSFGType(value);
    filterRequest[3].value = value;
    callTableGridApi();
    PPC = 1;
    FGC = 1;
    SFGT = 1;
    SFGC = 0;
    RMPM = 0;
    FGD = 1;
  };

  const handleFGDescription = (event: any) => {
    setselectSFGType("");
    setselectRMPMDescription("");
    setselectSFGCode("");
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    const {
      target: { value },
    } = event;
    setSelectFGDescription(value);
    filterRequest[2].value = value;
    callTableGridApi();
    PPC = 1;
    FGC = 1;
    SFGT = 0;
    SFGC = 0;
    RMPM = 0;
    FGD = 1;
  };

  const handleRMPMType = (event: any) => {
    const {
      target: { value },
    } = event;
    setselectRMPMDescription(value);
    filterRequest[7].value = value;
    callTableGridApi();
    PPC = 1;
    FGC = 1;
    SFGT = 1;
    SFGC = 1;
    RMPM = 1;
    FGD = 1;
  };

  const handleChangeSelectSFGCode = (event: any) => {
    setselectRMPMDescription("");
    filterRequest[5].value = "";

    const {
      target: { value },
    } = event;
    setselectSFGCode(value);
    filterRequest[folderModuleName === "module3" ? 6 : 4].value = value;
    callTableGridApi();
    PPC = 1;
    FGC = 1;
    SFGT = 1;
    SFGC = 1;
    RMPM = 0;
    FGD = 1;
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const downloadXLSFile = async () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    const requestParam = {
      usecaseId: 0,
      category_id: 0,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: filterList,
    };
    // const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "filter": filterList };
    const urls =
      folderModuleName === "module3"
        ? API_BASE_URL + LONG_Download_FGBOM_Module3
        : API_BASE_URL + LONG__FGBOM_DOWNLOAD_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response: any) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  const callTableGridApi = (selectedTable?: any) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      time_period: "",
      table: selectedTable ?? tableName,
      filter: filterList,
    };

    dispatch(ViewProductTableStart());
    const urls =
      folderModuleName === "module3"
        ? API_BASE_URL + LONG_GETALL_FGBOM_Module3
        : API_BASE_URL + LONG_GETALL_FGBOM;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);
          setRows(response.data);
          if (PPC === 0)
            setPackagingPlantCodeOptions(
              loadPackagingPlantCodeOptions(response.data)
            );
          if (FGC === 0) {
            setfgCodeOptions(loadFgCodeOption(response.data));
          }
          if (SFGT === 0) {
            setsfgTypeOption(loadSFGTypeOption(response.data));
          }
          if (FGD === 0) {
            setFGDescriptionOption(loadFGDecription(response.data));
          }
          if (RMPM === 0) {
            setRmpmDescriptionOption(loadRMPMOptions(response.data));
          }
          if (SFGC === 0) {
            setsfgCodeOption(loadSFGCodeOptions(response.data));
          }
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const loadPackagingPlantCodeOptions = (data: any) => {
    const packagingPlantCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = packagingPlantCodeOptions.find((obj: any) => {
        return obj.packaging_Plant_Code === item.packaging_Plant_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        packagingPlantCodeOptions.push({
          id: item.id,
          packaging_Plant_Code: item.packaging_Plant_Code,
        });
      }
    });
    return packagingPlantCodeOptions;
  };

  const loadFgCodeOption = (data: any) => {
    const fgCodeOption: any = [];
    data.map((item: any) => {
      const filteredItem = fgCodeOption.find((obj: any) => {
        return obj.fG_Code === item.fG_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        fgCodeOption.push({
          id: item.id,
          fG_Code: item.fG_Code,
        });
      }
    });
    return fgCodeOption;
  };

  const loadSFGTypeOption = (data: any) => {
    const sFGTypeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = sFGTypeOptions.find((obj: any) => {
        return obj.sfG_PM_Type === item.sfG_PM_Type;
      });
      if (filteredItem === undefined || filteredItem == null) {
        sFGTypeOptions.push({
          id: item.id,
          sfG_PM_Type: item.sfG_PM_Type,
        });
      }
    });
    return sFGTypeOptions;
  };

  const loadSFGCodeOptions = (data: any) => {
    const sfgCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = sfgCodeOptions.find((obj: any) => {
        return (
          (obj["sfG_PM_Code"] || obj["rM_PM_Code"]) ===
          (item["sfG_PM_Code"] || item["rM_PM_Code"])
        );
      });
      if (filteredItem === undefined || filteredItem == null) {
        folderModuleName === "module3"
          ? sfgCodeOptions.push({
              id: item.id,
              rM_PM_Code: item["sfG_PM_Code"] || item["rM_PM_Code"],
            })
          : sfgCodeOptions.push({
              id: item.id,
              sfG_PM_Code: item["sfG_PM_Code"] || item["rM_PM_Code"],
            });
      }
    });
    return sfgCodeOptions;
  };

  const loadRMPMOptions = (data: any) => {
    const RMPMOptions: any = [];
    data.map((item: any) => {
      const filteredItem = RMPMOptions.find((obj: any) => {
        return obj["rM_PM_Description"] === item["rM_PM_Description"];
      });
      if (filteredItem === undefined || filteredItem == null) {
        RMPMOptions.push({
          id: item.id,
          rM_PM_Description: item["rM_PM_Description"],
        });
      }
    });
    return RMPMOptions;
  };

  const loadFGDecription = (data: any) => {
    const FGDescriptionOptions: any = [];
    data.map((item: any) => {
      const filteredItem = FGDescriptionOptions.find((obj: any) => {
        return obj.fG_Description === item.fG_Description;
      });
      if (filteredItem === undefined || filteredItem == null) {
        FGDescriptionOptions.push({
          id: item.id,
          fG_Description: item.fG_Description,
        });
      }
    });
    return FGDescriptionOptions;
  };

  const getfiltersApi = (tableeName?: string) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      time_period: "",
      table: tableeName ?? tableName,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
    };

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_GETALL_FGBOM;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, "response");
          setPackagingPlantCodeOptions(
            loadPackagingPlantCodeOptions(response.data)
          );
          setfgCodeOptions(loadFgCodeOption(response.data));
          setsfgTypeOption(loadSFGTypeOption(response.data));
          setRmpmDescriptionOption(loadRMPMOptions(response.data));
          setFGDescriptionOption(loadFGDecription(response.data));
          setsfgCodeOption(loadSFGCodeOptions(response.data));
        }
      })
      .catch((error) => {
        dispatch(ViewProductTableError(error));
      });
  };

  const handleRestoreClicked = (e: any) => {
    setSelectPackagingPlantCode("");
    setselectFgCode("");
    setselectSFGType("");
    setselectRMPMDescription("");
    setselectSFGCode("");
    setSelectFGDescription("");
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    filterRequest[6].value = "";
    filterRequest[7].value = "";

    callTableGridApi(tableName);
  };

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable
  );

  const handleFetchEditData = (val: any) => {
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "packaging_Plant_Code",
      "packaging_Plant_Description",
      "fG_Code",
      "fG_Description",
      "sfG_PM_Type",
      "sfG_PM_Code",
      "sfG_PM_Description",
      "boM_Perc",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_Id: selectedFolderId,
        scenario_id: selectedScenarioId,
        packaging_Plant_Code: "",
        packaging_Plant_Description: "",
        fG_Code: "",
        fG_Description: "",
        rM_PM_Code: "",
        rM_PM_Description: 0,
        boM_Perc: 0,
        isNew: true,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };

  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    const urls =
      folderModuleName === "module3"
        ? API_BASE_URL + LONG_UPDATE_BULK_EDIT_FGB_API_Module3
        : API_BASE_URL + LONG_UPDATE_BULK_EDIT_FGB_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const payload = {
      moduleKey: Number(folderModuleName.slice(-1)),
      data: transformedRows,
    };

    putRequest(urls, payload, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        handleClose();
      });
    // setTimeout(() => {
    //   props?.onClose()
    // }, 200)
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited FG BOM table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="Shift And Changeover"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>FG BOM</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
              />
            </span>
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                <Select
                  id="simple-select-1"
                  value={selectPackagingPlantCode}
                  placeholder="Select Packaging Plant Code"
                  onChange={handleSelectPackagingPlantCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Packaging Plant Code</em>
                  </MenuItem>
                  {sortedPackagingPlantCodeNames?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.packaging_Plant_Code}>
                        {d.packaging_Plant_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                <Select
                  id="simple-select-2"
                  value={selectFgCode}
                  placeholder="Select Demand Location Code"
                  onChange={handleSelectFgCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>FG Code</em>
                  </MenuItem>
                  {fgCodeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.fG_Code}>
                        {d.fG_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Product Code</InputLabel> */}
                <Select
                  id="simple-select-2"
                  value={selectFGDescription}
                  placeholder="Select Product Code"
                  onChange={handleFGDescription}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>FG Description</em>
                  </MenuItem>
                  {fgDescriptionOption?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.fG_Description}>
                        {d.fG_Description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            {(folderModuleName === "module1" ||
              folderModuleName === "module5" ||
              folderModuleName === "module2" ||
              folderModuleName === "module6") && (
              <>
                <div className="filter-item">
                  <FormControl
                    fullWidth
                    className="selectDropdown ddoverlap-fix"
                  >
                    {/* <InputLabel>Product Code</InputLabel> */}
                    <Select
                      id="simple-select-2"
                      value={selectSFGType}
                      placeholder="Select Product Code"
                      onChange={handleSFGType}
                      className="select-short-term"
                      inputProps={{ "aria-label": "Without label" }}
                      displayEmpty
                    >
                      <MenuItem value="">
                        <em>SFG PM Type</em>
                      </MenuItem>
                      {sfgTypeOption?.map((d: any) => {
                        return (
                          <MenuItem key={d} value={d.sfG_PM_Type}>
                            {d.sfG_PM_Type}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
              </>
            )}

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                <Select
                  id="simple-select-4"
                  value={selectSFGCode}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectSFGCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    {folderModuleName === "module3" ? (
                      <em>RMPM Code</em>
                    ) : (
                      <em>SFG PM Code</em>
                    )}
                  </MenuItem>
                  {sfgCodeOption?.map((d: any) => {
                    return (
                      <MenuItem
                        key={d}
                        value={
                          folderModuleName === "module3"
                            ? d?.rM_PM_Code
                            : d?.sfG_PM_Code
                        }
                      >
                        {folderModuleName === "module3"
                          ? d?.rM_PM_Code
                          : d?.sfG_PM_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            {folderModuleName === "module3" && (
              <>
                <div className="filter-item">
                  <FormControl
                    fullWidth
                    className="selectDropdown ddoverlap-fix"
                  >
                    {/* <InputLabel>Product Code</InputLabel> */}
                    <Select
                      id="simple-select-2"
                      value={selectRMPMDescription}
                      placeholder="Select Product Code"
                      onChange={handleRMPMType}
                      className="select-short-term"
                      inputProps={{ "aria-label": "Without label" }}
                      displayEmpty
                    >
                      <MenuItem value="">
                        <em>RMPM Description</em>
                      </MenuItem>
                      {rmpmDescriptionOption?.map((d: any) => {
                        return (
                          <MenuItem key={d} value={d.rM_PM_Description}>
                            {d.rM_PM_Description}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
              </>
            )}

            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}

            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={(e) => handleDownload(e)}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <FGBomTable
          ref={childRef}
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default FGBom;
